import router from '@/router'
import { unsetHsBot } from '@/store/gamestate/gamestate'
import { getRouteNameByStudyTab } from '@/store/router/router'
import { SNK } from '@/helpers/helpers'
import { namespaces } from '@/helpers/constants'

const state = () => ({})

const getters = {
  poker_diss_history_calls: (state, getters, rootState, rootGetters) => namespace => {
    if (
      router.currentRoute.value.name === 'StudySolutions' &&
      rootGetters[SNK('sol_elite', namespace)].is_using
    ) {
      if (rootGetters.sw_tabs_study === 'reports' && namespace !== namespaces.REPORTS) {
        return true
      }
      if (
        ['strategy', 'range', 'breakdown'].includes(rootGetters.sw_tabs_study) &&
        namespace !== namespaces.STUDY
      ) {
        return true
      }
    }
    return false
  },
}

const actions = {
  poker_show_analyzed_handV2({ state, commit, dispatch, getters }, result) {
    if (result?.response?.status === 200) {
      const id = result.response.data.id
      dispatch('globals_drawer', {
        id: 'analyze_handV4',
        open: true,
        content: {
          hand_id: id,
        },
        maximized: getters.globals_drawer.maximized,
      })
      router.replace({
        query: {
          hand_detail: id,
        },
      })

      commit('messages_reset')
      router
        .replace({
          query: {
            ...router.currentRoute.value.query,
            hand_detail: result?.response?.data?.id,
          },
        })
        .catch(() => {})

      dispatch('account_settings')
    }
    if (result?.error?.status === 429) {
      dispatch('account_settings')
    }
  },
  poker_show_board_dialog({ dispatch, rootGetters }, { namespace }) {
    if (namespace?.includes('tmp')) {
      return
    }

    const street = rootGetters[SNK('street', namespace)]
    const preflopOnlyGametype = rootGetters[SNK('preflopOnlyGametype', namespace)]
    const solElite = rootGetters[SNK('sol_elite', namespace)]

    if (street !== 'preflop' && !rootGetters[SNK('query_dialogs', namespace)]) {
      const history_spots = rootGetters[SNK('history_spots', namespace)]
      let streetBoard = rootGetters[SNK('street_board', namespace)](street)
      let boardIncomplete = streetBoard.includes('Ee')

      if (boardIncomplete) {
        const pathName = getRouteNameByStudyTab(router, rootGetters)

        let dialog = `cards-dialog${namespace ? `_namespace-${namespace}` : ''}`
        if (
          pathName === 'StudyReports' ||
          (rootGetters.sw_tabs_study === 'reports' &&
            router.currentRoute.value.name === 'StudySolutions')
        ) {
          if (street === 'turn') {
            streetBoard = rootGetters[SNK('street_board', namespace)]('flop')
            boardIncomplete = streetBoard.includes('Ee')
            if (boardIncomplete) {
              dispatch('router_set_dialogs', dialog)
              return
            }
          }
          return
        }

        if (pathName === 'StudySolutions') {
          if (preflopOnlyGametype && !solElite.want_use) {
            return
          }

          const tmpNamespace = 'tmp/primary'
          const cpParams = {
            from_namespace: null,
            to_namespace: tmpNamespace,
            queryGroup: 'board-filter',
          }
          dispatch('poker_copy_module', cpParams)

          dispatch('router_set_dialogs', dialog)
          return
        }

        if (pathName === 'PracticeRangeBuilder') {
          if (preflopOnlyGametype && !solElite.want_use) {
            return
          }

          const streetSpots = history_spots.filter(spot => spot.street === street)
          if (streetSpots.length === 1) {
            const tab = street
            const tmpNamespace = 'tmp/primary'

            const cpParams = {
              from_namespace: null,
              to_namespace: tmpNamespace,
              queryGroup: 'board-filter',
            }
            dispatch('poker_copy_module', cpParams)

            dialog = 'practice-filter-dialog'
            dialog = `${dialog}_tab-${tab}_tmpNamespace-${tmpNamespace}`
            dispatch('router_set_dialogs', dialog)
          }
        }
      }
    }
  },
  poker_copy_module(
    { state, commit, dispatch, getters },
    { from_namespace = 'unset', to_namespace = 'unset', queryGroup, toModuleParams = {} },
  ) {
    const rFrom = `${from_namespace ? `${from_namespace}/` : ''}`
    const rTo = `${to_namespace ? `${to_namespace}/` : ''}`

    // TODO -  'router-to-gmf-selektor' move it to spec action for openig and closing that dialog
    // if (rFrom === rTo && queryGroup !== 'router-to-gmf-selektor') {
    //   console.log('poker_copy_module - copying state to the same module', to_namespace)
    //   return
    // }

    if (queryGroup === 'trainer') {
      const query_gameformat = getters[`${rFrom}query_gameformat`]
      const query_cussol = getters[`${rFrom}query_cussol`]
      const query_gmfFilter = getters[`${rFrom}query_gmfFilter`]
      const query_gmfTable = getters[`${rFrom}query_gmfTable`]
      const query_cards = getters[`${rFrom}query_cards`]
      const query_history = getters[`${rFrom}query_history`]
      const query_board_filter = getters[`${rFrom}query_board_filter`]
      const query_fullhand_setup = getters[`${rFrom}query_fullhand_setup`]
      const history_spots = getters[`${rFrom}history_spots`]

      let hSpots = JSON.parse(JSON.stringify(history_spots))

      const query = JSON.parse(
        JSON.stringify({
          ...query_gameformat,
          ...query_cussol,
          ...query_gmfFilter,
          ...query_gmfTable,
          ...query_cards,
          ...query_history,
          ...query_board_filter,
          ...query_fullhand_setup,
          ...toModuleParams, // right now only in preferences fh_trainer_tables
        }),
      )
      if (query.solution_type !== 'custom' && query.fh_start_spot === 'custom_spot') {
        // start where the hand originally started
        let trainer_hand_settings = getters[`${rFrom}trainer_hand_settings`]
        if (trainer_hand_settings) {
          trainer_hand_settings = JSON.parse(trainer_hand_settings)
          hSpots = trainer_hand_settings?.history_spots || hSpots
        }
      }

      const storeMutation = `${rTo}gamestate_set`
      commit(storeMutation, {
        key: 'history_spots',
        value: hSpots,
      })

      const storeAction = `${rTo}router_update_query`
      dispatch(storeAction, {
        query,
        push: false,
        replace: to_namespace === 'tra/alpha',
        saveLocally: to_namespace === 'tra/alpha',
      })

      const api_poker_shortcuts = getters.api_get('api_poker_shortcuts', from_namespace)
      commit('api_update', {
        key: 'api_poker_shortcuts',
        result: api_poker_shortcuts,
        namespace: to_namespace,
        replace: true,
      })
      return
    }

    if (queryGroup === 'router-to-gmf-selektor') {
      const query_cussol = getters[`${rFrom}query_cussol`]

      let storeAction = `${rTo}router_update_query`
      dispatch(storeAction, {
        query: query_cussol,
        push: false,
        replace: false,
        saveLocally: false,
      })

      const query_gameformat = getters[`${rFrom}query_gameformat`]
      const query_gmfFilter = getters[`${rFrom}query_gmfFilter`]
      const query_gmfTable = getters[`${rFrom}query_gmfTable`]

      const gameformat = getters[`${rFrom}gameformat`]
      // let storeAction = `${rTo}gmfs_set_gameformat`
      // dispatch(storeAction, { gameformat })
      // debugger

      const stacksList = query_gameformat.stacks_list.split(',').filter(i => i)
      const depthList = query_gameformat.depth_list
        .split(',')
        .filter(i => i)
        .map(i => Number(i))
      const avgStackList = query_gameformat.average_stack
        .split(',')
        .filter(i => i)
        .map(i => Number(i))
      // debugger

      storeAction = `${rTo}gmfs_toggle_list`
      dispatch(storeAction, { list: depthList, listKey: 'gmfs_depthList' })
      dispatch(storeAction, { list: stacksList, listKey: 'gmfs_stacksList' })
      dispatch(storeAction, { list: avgStackList, listKey: 'gmfs_avgStackList' })

      // console.log(query_gmfFilter)
      const tableSelectedFilters = {
        stacks_type: query_gmfFilter.gmff_stacks_type.split(',').filter(i => i),

        opening_type: query_gmfFilter.gmff_opening_type.split(',').filter(i => i),
        tournament_phase: query_gmfFilter.gmff_tournament_phase.split(',').filter(i => i),
        players: query_gmfFilter.gmff_players
          .split(',')
          .filter(i => i)
          .map(i => Number(i)),
        variant: query_gmfFilter.gmff_variant.split(',').filter(i => i),

        cash_drop: query_gmfFilter.gmff_cash_drop.split(',').filter(i => i),

        biggest_stack: query_gmfFilter.gmff_biggest_stack
          .split(',')
          .filter(i => i)
          .map(i => Number(i)),
        depth: query_gmfFilter.gmff_depth
          .split(',')
          .filter(i => i)
          .map(i => Number(i)),
        type: query_gmfFilter.gmff_type.split(',').filter(i => i),
        rake: query_gmfFilter.gmff_rake.split(',').filter(i => i),
        opening_size: query_gmfFilter.gmff_opening_size.split(',').filter(i => i),
        _3bet_size: query_gmfFilter.gmff__3bet_size.split(',').filter(i => i),
        simplified_position: query_gmfFilter.gmff_simplified_position.split(',').filter(i => i),
        favorite: query_gmfFilter.gmff_favorite === 'true',
      }

      storeAction = `${rTo}gmfs_set`
      dispatch(storeAction, { key: 'gmfs_table_selectedFilters', value: tableSelectedFilters })

      // stacks-table
      // console.log('router-to-gmf-selektor', query_gmfTable)
      dispatch(storeAction, { key: 'gmfs_table_sortKey', value: query_gmfTable.gmfft_sort_key })
      dispatch(storeAction, { key: 'gmfs_table_sortOrder', value: query_gmfTable.gmfft_sort_order })

      storeAction = `${rTo}gmfs_set_gameformat`
      dispatch(storeAction, { gameformat, force_recomputeBase: true })
      return
    }

    if (queryGroup === 'gmf-selektor-to-router') {
      const gmf = getters[`${rFrom}gmfs_gameformat`]
      const depthList = getters[`${rFrom}gmfs_depthList`]
      const stacksList = getters[`${rFrom}gmfs_stacksList`]
      const avgStackList = getters[`${rFrom}gmfs_avgStackList`]
      const selectedFilters = getters[`${rFrom}gmfs_table_selectedFilters`]
      const sortKey = getters[`${rFrom}gmfs_table_sortKey`]
      const sortOrder = getters[`${rFrom}gmfs_table_sortOrder`]

      const query_gameformat = {
        gametype: gmf.gametype,
        depth: gmf.depth,
        stacks: gmf.stacks,
        depth_list: depthList.join(','),
        stacks_list: stacksList.join(','),
        average_stack: avgStackList.join(','),
      }

      const query_cussol = getters[`${rFrom}query_cussol`]

      const query_gmfFilter = {
        gmff_stacks_type: selectedFilters.stacks_type.join(','),

        gmff_opening_type: selectedFilters.opening_type.join(','),
        gmff_tournament_phase: selectedFilters.tournament_phase.join(','),
        gmff_players: selectedFilters.players.join(','),
        gmff_variant: selectedFilters.variant.join(','),

        gmff_cash_drop: selectedFilters.cash_drop.join(','),

        gmff_biggest_stack: selectedFilters.biggest_stack.join(','),
        gmff_depth: selectedFilters.depth.join(','),
        gmff_type: selectedFilters.type.join(','),
        gmff_rake: selectedFilters.rake.join(','),
        gmff_opening_size: selectedFilters.opening_size.join(','),
        gmff__3bet_size: selectedFilters._3bet_size.join(','),
        gmff_simplified_position: selectedFilters.simplified_position.join(','),
        gmff_favorite: selectedFilters.favorite || '',
      }

      const query_gmfTable = {
        gmfft_sort_key: sortKey,
        gmfft_sort_order: sortOrder,
      }
      // console.log(query_gameformat)
      let storeAction = `${rTo}router_update_query`
      // debugger
      const query = {
        ...query_cussol,
        ...query_gameformat,
        ...query_gmfFilter,
        ...query_gmfTable,
      }
      // console.log(query)
      // debugger
      dispatch(storeAction, {
        query,
        push: false,
        replace: to_namespace === 'tra/alpha',
        saveLocally: to_namespace === 'tra/alpha',
      })

      storeAction = `${rTo}gmfs_set_gameformat`
      dispatch(storeAction, { gameformat: gmf, force_recomputeBase: true })
      return
    }

    if (queryGroup === 'replay') {
      const query_query = getters[`${rFrom}query_query`]
      const trainer_state_props = getters[`${rFrom}trainer_state_props`]
      const gamestate_state_props = getters[`${rFrom}gamestate_state_props`]

      commit(`${rTo}router_reset`, query_query)
      commit(`${rTo}trainer_reset`, trainer_state_props)
      commit(`${rTo}gamestate_reset`, gamestate_state_props)

      // copy hSpots for playFromHere
      const history_spots = getters[`${rFrom}history_spots`]
      const hSpots = JSON.parse(JSON.stringify(history_spots))
      const storeMutation = `${rTo}gamestate_set`
      commit(storeMutation, {
        key: 'history_spots',
        value: hSpots,
      })
      // console.log(history_spots)
      // console.log(query_query)
      // debugger
      return
    }

    if (queryGroup === 'board-filter') {
      const query_board = getters[`${rFrom}query_board`]
      const query_board_filter = getters[`${rFrom}query_board_filter`]
      const query = JSON.parse(
        JSON.stringify({
          board: query_board,
          ...query_board_filter,
        }),
      )

      const storeAction = `${rTo}router_update_query`
      dispatch(storeAction, {
        query,
        push: false,
        replace: false,
        saveLocally: false,
      })
      return
    }

    if (queryGroup === 'router') {
      const query_query = getters[`${rFrom}query_query`]
      const res = JSON.parse(JSON.stringify(query_query))
      const storeAction = `${rTo}router_reset`
      // console.log(res)
      // debugger
      dispatch(storeAction, res)
    }
    if (queryGroup === 'nodedit') {
      const query_query = getters[`${rFrom}query_query`]
      const gamestate_state_props = getters[`${rFrom}gamestate_state_props`]

      commit(`${rTo}router_reset`, query_query)
      commit(`${rTo}gamestate_reset`, gamestate_state_props)

      const custom_solution = getters.api_get('api_poker_custom_solution', from_namespace)
      commit('api_update', {
        key: 'api_poker_custom_solution',
        result: custom_solution,
        namespace: to_namespace,
        replace: true,
      })
      return
    }

    if (queryGroup === 'sync-study-reports') {
      // for presolved we can sync everything all the time
      const from_sol_eliteWantUseButMustCreate = getters[`${rFrom}sol_eliteWantUseButMustCreate`]
      const from_solutionType = getters[`${rFrom}query_solution_type`]

      if (from_sol_eliteWantUseButMustCreate || from_solutionType === 'gwiz') {
        const from_query_study_history = getters[`${rFrom}query_study_history`]
        const query = {
          ...from_query_study_history,
          ...getters[`${rFrom}query_gmfSelector`],
          soltab: toModuleParams.soltab,
          gmfs_solution_tab: toModuleParams.gmfs_solution_tab,
        }
        dispatch(`${rTo}router_update_query`, {
          query,
          push: false,
          replace: false,
          saveLocally: true,
        })

        commit(
          `${rTo}gamestate_set`,
          {
            key: 'history_spots',
            value: getters[`${rFrom}history_spots`],
          },
          { root: true },
        )

        // gmf-selector we can sync only once
        const from_gameformat = getters[`${rFrom}gameformat`]
        const to_gameformat = getters[`${rTo}gameformat`]
        if (from_gameformat.gametype === to_gameformat.gametype) return
        dispatch('poker_copy_module', {
          from_namespace,
          to_namespace,
          queryGroup: 'gmf-selektor',
        })
        return
      }

      // for custom we can sync only the cussol+tree ids and we have to reset gamestate actions
      // switching to study tab will not then change the solution but actions will be reseted
      const to_solutionType = getters[`${rTo}query_solution_type`]
      const from_query_cussol = getters[`${rFrom}query_cussol`]
      const to_query_cussol = getters[`${rTo}query_cussol`]
      if (
        to_solutionType === 'gwiz' ||
        to_query_cussol.custree_id !== from_query_cussol.custree_id
      ) {
        const query = {
          ...from_query_cussol,
          ...getters[`${rFrom}query_gmfSelector`],
          soltab: toModuleParams.soltab,
          gmfs_solution_tab: toModuleParams.gmfs_solution_tab,
        }
        dispatch(`${rTo}gamestate_reset_history`, {
          query,
          routerParams: {
            push: false,
            replace: false,
            saveLocally: true,
          },
        })

        // gmf-selector we can sync only once
        const from_gameformat = getters[`${rFrom}gameformat`]
        const to_gameformat = getters[`${rTo}gameformat`]
        if (from_gameformat.gametype === to_gameformat.gametype) return
        dispatch('poker_copy_module', {
          from_namespace,
          to_namespace,
          queryGroup: 'gmf-selektor',
        })
        return
      }

      // WE have to sync soltab always
      if (toModuleParams.soltab) {
        commit(`${rTo}router_set`, {
          key: 'soltab',
          value: toModuleParams.soltab,
        })
        commit(`${rTo}router_set`, {
          key: 'gmfs_solution_tab',
          value: toModuleParams.gmfs_solution_tab,
        })
      }

      return
    }

    if (queryGroup === 'gmf-selektor') {
      const gmfs_state = getters[`${rFrom}gmfs_state`]
      const res = JSON.parse(JSON.stringify(gmfs_state))
      const storeAction = `${rTo}gmfs_reset`
      dispatch(storeAction, res)
    }
  },
  poker_update_module({ state, commit, dispatch, getters }, { namespace = 'unset', queryGroup }) {
    const gNmspc = `${namespace ? `${namespace}/` : ''}`
    if (queryGroup === 'trainer_filter') {
      const history_spots = getters[`${gNmspc}history_spots`]
      let hSpots = JSON.parse(JSON.stringify(history_spots))
      hSpots = unsetHsBot({ history_spots: hSpots })
      const storeMutation = `${gNmspc}gamestate_set`
      commit(storeMutation, {
        key: 'history_spots',
        value: hSpots,
      })
    }
  },
  poker_sync_study_tabs({ state, commit, dispatch, rootGetters }, { soltab }) {
    const currentSoltab = rootGetters.sw_tabs_study
    const switchingStudyReportsOrViceVersa =
      (currentSoltab !== 'reports' && soltab === 'reports') ||
      (currentSoltab === 'reports' && soltab !== 'reports')
    if (switchingStudyReportsOrViceVersa) {
      dispatch('poker_copy_module', {
        from_namespace: currentSoltab === 'reports' ? namespaces.REPORTS : namespaces.STUDY,
        to_namespace: currentSoltab === 'reports' ? namespaces.STUDY : namespaces.REPORTS,
        queryGroup: 'sync-study-reports',
        toModuleParams: {
          soltab,
          gmfs_solution_tab: soltab === 'reports' ? 'ai_reports' : 'ai_sols',
        },
      })
    }
  },
  poker_replay_spot(
    { dispatch, getters },
    { spot_id = 0, lastSpot = false, namespace = '', hasSounds },
  ) {
    const history_spots = getters[`${namespace}/history_spots`]

    let spotId = spot_id
    if (lastSpot) {
      spotId = history_spots.length - 1
    }
    const hSpotAnim = history_spots.find(spot => spot.id === spotId - 1)
    const hSpot = history_spots.find(spot => spot.id === spotId)
    if (hSpotAnim) {
      dispatch(`${namespace}/anim_player_action`, { history_spot: hSpotAnim, hasSounds })
    }
    if (hSpot) {
      // Check if we're on new Analyzer routes where we want to prevent URL changes
      const currentPath = router.currentRoute.value.path

      const isAnalyzeRoute =
        currentPath.startsWith('/analyze/v4') || currentPath.startsWith('/analyze/reports')

      dispatch(`${namespace}/gamestate_set_history`, {
        history_spots,
        spot_id: spotId,
        push: false,
        ...(isAnalyzeRoute ? { replace: false } : {}),
      })
    }
  },
  poker_trainer_api_reset({ state, commit, dispatch, getters }, { namespace }) {
    dispatch(`${namespace}/anim_player_reset`)
    const trainer_practice_hand_id = getters[`${namespace}/trainer_practice_hand_id`]

    dispatch('api_cancel_pending_requests', {
      callIds: [
        `poker/practice/practice-hands/`,
        `poker/practice/practice-hands/${trainer_practice_hand_id}/hero-situation/`,
        `poker/practice/practice-hands/${trainer_practice_hand_id}/bot-action/`,
        `poker/practice/practice-hands/${trainer_practice_hand_id}/showdown/`,
      ],
    })
    const calls = [
      'api_practice_setup',
      'api_practice',
      'api_practice_bot_action',
      'api_practice_showdown',
    ]
    calls.forEach(key => {
      commit('api_reset', { namespace, key })
    })

    // TR-TODOanimation
    // commit('player_animation_reset')
  },
  poker_trainer_hide_loading({ state, commit, dispatch, getters }, { namespace = '' }) {
    const calls = [
      'api_practice_setup',
      'api_practice',
      'api_practice_bot_action',
      'api_practice_showdown',
    ]
    calls.forEach(key => {
      if (getters.api_get(key, namespace).loading) {
        commit('api_update_data', { namespace, key, result: { loading: false, loaded: true } })
      }
    })
  },
  poker_gamestate_history_cancel_pending_requests({ state, commit, dispatch, getters }) {
    dispatch('api_cancel_pending_requests', {
      callIds: [
        'poker/history/', // TODO has uncancelable politic
        'poker/next-actions/', // TODO has uncancelable politic
        'poker/tree-preview/',
      ],
    })
  },
}
const mutations = {
  poker_set(state, { key, value }) {
    state[key] = value
  },
}

export default {
  state,
  getters,
  actions,
  mutations,
}
